// extracted by mini-css-extract-plugin
export default {"row":"CardTrio-module--row--756ef","col":"CardTrio-module--col--b81ac","icon":"CardTrio-module--icon--8ae70","stretch":"CardTrio-module--stretch--e4937"};